import { render } from "./TheValueCurrency.vue?vue&type=template&id=b05a979a&scoped=true&lang=html"
import script from "./TheValueCurrency.vue?vue&type=script&lang=js"
export * from "./TheValueCurrency.vue?vue&type=script&lang=js"

import "./TheValueCurrency.vue?vue&type=style&index=0&id=b05a979a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b05a979a"]])

export default __exports__